import { render, staticRenderFns } from "./RadioSelect.vue?vue&type=template&id=038557cf&scoped=true&lang=pug"
import script from "./RadioSelect.vue?vue&type=script&lang=js"
export * from "./RadioSelect.vue?vue&type=script&lang=js"
import style0 from "./RadioSelect.vue?vue&type=style&index=0&id=038557cf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038557cf",
  null
  
)

export default component.exports